@if (label) {
    <label class="text-white">{{ label }}</label>
}
<input type="{{ type }}" autocomplete="{{ autocomplete }}" placeholder="{{ placeholder }}" class="form-control" [required]="required" [disabled]="disabled" [value]="value" (input)="input($event.target)" /> 
@if (formControl.touched && formControl.invalid) {
    <label class="is-invalid">{{ errorMsg }}</label>
}
